import { ScopeReportChangeType } from '@kaiizen/kai-pro-api';
import { GroupingMode, ReportType, ScopeReportLineItem } from '@kaiizen/kai-reports';
import { createContext, useContext } from 'react';

interface ScopePrintPreviewContextValue {
  scan: any;
  scanLifecycleStatus?: string;
  groupingMode: GroupingMode;
  setGroupingMode: (mode: GroupingMode) => void;
  searchHighlightedTaskId?: string;
  onLineItemClick?: (event: React.MouseEvent<HTMLTableRowElement>, item: ScopeReportLineItem, lineItemId: string) => void;
  reportType: ReportType;
  searchableSowData?: ScopeReportLineItem[];
  currentDropdown?: { groupId: string; taskId?: string };
  setCurrentDropdown: (dropdown: { groupId: string; taskId?: string } | undefined) => void;
  changeOrderLookup?: Map<string, ScopeReportChangeType>;
}

const ScopePrintPreviewContext = createContext<ScopePrintPreviewContextValue | undefined>(undefined);

export const useScopePrintPreviewContext = () => {
  const context = useContext(ScopePrintPreviewContext);
  if (!context) {
    throw new Error('useScopePrintPreviewContext must be used within ScopePrintPreviewProvider');
  }
  return context;
};

export const ScopePrintPreviewProvider = ScopePrintPreviewContext.Provider;
